<template>
  <div class="sell">
    <van-search
      v-model="value"
      show-action
      label="姓名"
      placeholder="请输入搜索关键词"
      @search="onSearch"
    >
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>

    <div class="withdraw-tab">
      <van-tabs v-model="active" @change="onClick">
        <van-tab :title="parent_title"></van-tab>
        <van-tab :title="parent_two_title">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div class="orders-li" v-for="(item, k) in list" :key="k">
                <div class="o-li-title" v-if="item.member">
                  <span class="o-li-title-l">{{ item.order_no }}</span>
                  <span class="o-li-title-r">{{ item.created_at }}-{{ item.member.nickname }}</span>
                </div>
                <div class="o-main">
                  <div class="img">
                    <img :src="item.goods.image[0].file.full_url" />
                  </div>
                  <div class="info">
                    <h3>{{ item.goods_name }}</h3>
                    <div class="price">
                      <span>￥{{ item.pay_price }}</span>
                      <span class="right sp2">x{{ item.purchases }}</span>
                    </div>
                    <div class="pay-price">
                      <span class="p-sp-2">实付：￥{{ item.pay_price }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </van-tab>

      </van-tabs>
    </div>


    <Floating toUrl="/users/index" />
    <wxNoShare />
  </div>
</template>

<script>
  import { Search, Tab, Tabs, Empty, Image as VanImage, List, PullRefresh } from 'vant'

  export default {
    components: {
      [Search.name]: Search,
      [Tabs.name]: Tabs,
      [Tab.name]: Tab,
      [Empty.name]: Empty,
      [VanImage.name]: VanImage,
      [List.name]: List,
      [PullRefresh.name]: PullRefresh,
    },
    name: 'sell',
    data () {
      return {
        value: '',
        active: 1,
        page: 1,
        list: [],
        parent_title: '团队成员',
        parent_two_title: '团队订单',
        loading: false,
        finished: false,
        refreshing: false,
      }
    },
    created () {
      //
    },
    methods: {
      onLoad () {
        this.$api.get('agency/sell', {page: this.page, type:this.active}, r => {
          this.parent_title = '团队成员（'+r.data.parent_count+'）'
          this.parent_two_title = '团队订单（'+r.data.parent_two_count+'）'
          let data = r.data.list.data
          this.list.push.apply(this.list, data)
          this.loading = false
          if (this.page >= r.data.list.last_page) {
            this.finished = true;
          }
          this.page = this.page + 1
        })
      },
      onRefresh () {
        this.page = this.page + 1
        // 清空列表数据
        this.finished = false;

        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        this.onLoad();
      },
      onSearch() {

      },
      onClick(name, title) {
        if(name == 0){
          //this.$router.push({name: 'sell'})
          window.location.href = "/agency/sell"
        }
      }
    }
  }
</script>

<style scoped>
  .sell{
    width: 100%;
    height: 100%;
    background-color: #ffffff;
  }
  .sell-main{
    overflow: hidden;
    padding:10px 0;
  }
  .sell-main ul{
    padding:10px 15px;
  }
  .sell-main ul li{
    font-size: 13px;
    overflow: hidden;
    margin-bottom: 15px;
  }
  .sell-main ul li .img{
    float: left;
    width: 18%;
  }
  .sell-main ul li .sell-li-r{
    float: right;
    width: 80%;
  }
  .sell-main ul li .sell-li-r span{
    display: inline-block;
    width: 32%;
    line-height: 2.5rem;
    overflow: hidden;
    height: 2.5rem;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .sell-main ul li .sell-li-r .grade{
    width: 30%;
    text-align: right;
  }
  .orders-li{
    overflow: hidden;
    background: #ffffff;
    border-radius: 8px;
    margin: 10px;
    padding:15px;
  }
  .orders-li .o-li-title{
    font-size: 14px;
    overflow: hidden;
    margin-bottom: 10px;
  }
  .orders-li .o-li-title .o-li-title-l{
    float: left;
    font-weight: bold;
  }
  .orders-li .o-li-title .o-li-title-r{
    float: right;
    color: #ED6A0C;
  }
  .orders-li .o-main{
    overflow: hidden;
  }
  .orders-li .o-main .img{
    float: left;
    width: 35%;
    height: 80px;
  }
  .orders-li .o-main .img img{
    width: 100%;
    height: 80px;
  }
  .orders-li .o-main .info{
    float: right;
    width: 60%;
    margin-left: 5%;
  }
  .orders-li .o-main .info h3{
    margin: 0;
    font-size: 14px;
    font-weight: normal;
    height: 30px;
  }
  .orders-li .o-main .info .price{
    font-size: 14px;
  }
  .orders-li .o-main .info .price .sp2{
    color:#646566;
  }
  .orders-li .o-main .info .pay-price{
    font-size: 14px;
    margin-top: 5px;
  }
  .orders-li .o-main .info .pay-price .p-sp-2{
    float: right;
  }
  .orders-li .o-bottom{
    overflow: hidden;
    margin-top: 10px;
  }
  .orders-li .o-bottom .o-wl{
    float: right;
    font-size: 14px;
    border:1px solid #D3D3D3;
    border-radius: 15px;
    padding: 5px 20px;
    color:#6D6D6D;
    margin-left: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/views/agency/sellOrders.vue